import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PrivacyNoticeLink from './PrivacyNoticeLink';
import './FeedbackPopup.css';

export const FEEDBACK_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSdGLC_H8OEY3l_EmBAqxKSCfri8xjrNfXEIZUdJrt4c1iJjRA/viewform?usp=header';
const FeedbackDockContext = createContext(null);

function getFeedbackFormUrl(email, embedded = false) {
  const url = new URL(FEEDBACK_FORM_URL);
  if (embedded) {
    url.searchParams.delete('usp');
    url.searchParams.set('embedded', 'true');
  }
  if (email) url.searchParams.set('emailAddress', email);
  return url.toString();
}

export function useFeedbackTopControl() {
  return useContext(FeedbackDockContext);
}

export default function FeedbackPopup({ children }: any) {
  const [topControls, setTopControls] = useState<any>(0);
  const [open, setOpen] = useState<any>(false);
  const dialogRef = useRef<any>(null);
  const triggerRef = useRef<any>(null);
  const { pathname } = useLocation();
  const { user } = useAuth();
  const email = user?.email?.trim() || '';
  const showFeedback = !/^\/login\/?$/i.test(pathname);

  useEffect(() => {
    setOpen(false);
  }, [pathname, email]);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open) dialog.showModal();
    else if (dialog.open) dialog.close();
  }, [open, showFeedback]);

  const close = () => {
    setOpen(false);
    triggerRef.current?.focus();
  };

  const trigger = (
    <button
      ref={triggerRef}
      type="button"
      className={`ae-floating-control ae-feedback-trigger${topControls > 0 ? ' ae-feedback-trigger-with-top' : ''}`}
      aria-haspopup="dialog"
      onClick={() => setOpen(true)}
    >
      Feedback
    </button>
  );

  return (
    <FeedbackDockContext.Provider value={setTopControls}>
      {children}
      {showFeedback && <>
      {trigger}
      <dialog ref={dialogRef} className="ae-feedback-dialog" aria-labelledby="ae-feedback-title"
        onCancel={(event) => { event.preventDefault(); close(); }} onClose={close}>
        <div className="ae-feedback-header">
          <h2 id="ae-feedback-title">Share your feedback</h2>
          <button type="button" onClick={close} aria-label="Close feedback">Close</button>
        </div>
        <p className="ae-feedback-intro">
          This form is hosted by Google. If it does not load,{' '}
          <a href={getFeedbackFormUrl(email)} target="_blank" rel="noopener noreferrer">open the feedback form in a new tab</a>.
        </p>
        <p className="ae-feedback-intro">
          {email
            ? 'Your account email is prefilled in the Google form. You can change it before submitting.'
            : 'Please enter your email in the form; no account email is available to prefill.'}
        </p>
        <p className="ae-feedback-intro"><PrivacyNoticeLink /></p>
        {open && <iframe title="Academic Eye general feedback form"
          src={getFeedbackFormUrl(email, true)} />}
      </dialog>
      </>}
    </FeedbackDockContext.Provider>
  );
}
